import React, { useContext } from 'react';

export const MODE_SEARCH = 'search';
export const MODE_LIST = 'list';

/** @type {import('react').Context<PlanPickerContextBag>} */
export const PlanPickerContext = React.createContext({
    mode: MODE_LIST,
    options: [],
    total: 'unknown',
    isWaitingForInitialData: true,
    loadOptionsByIndex: () => {},
    searchQuery: '',
    updateSearchQuery: () => {},
    selectedId: null,
    value: null,
    onChange: () => {},
    selectRef: { current: null }
});

export default function usePlanPickerContext() {
    return useContext(PlanPickerContext);
}

/**
 * @typedef {object} PlanPickerContextBag
 * @prop {'sync' | 'async'} dataStrategy
 * @prop {PlanPickerMode} mode
 * @prop {import('./usePlanPickerApi/items').PlanPickerItemWithStatus[]} options
 * @prop {number | 'unknown'} total
 * @prop {boolean} isWaitingForInitialData
 * @prop {(indexes: import('./usePlanPickerApi/pagination').Index[], signal: AbortSignal) => void} loadOptionsByIndex
 * @prop {string} searchQuery
 * @prop {(inputValue: string) => void} updateSearchQuery
 * @prop {string | null} selectedId
 * @prop {import('./usePlanPickerApi/items').PlanPickerItemWithStatus | null} value
 * @prop {(selectedItem: import('./usePlanPickerApi/items').PlanPickerItemWithStatus) => void} onChange
 * @prop {import('react').RefObject<import('react-select').SelectInstance<import('../usePlanPickerApi/items').PlanPickerItemWithStatus> | null>} selectRef
 */

/**
 * @typedef {typeof MODE_LIST | typeof MODE_SEARCH} PlanPickerMode
 */
